import useOrgsCountByGroup from 'hooks/useOrgsCountByGroup';
import React from 'react';

export default function CountOrgsByGroup({ groupId }: { groupId: string }) {
  const count = useOrgsCountByGroup(groupId);
  return <div>{count}</div>;
}
